/**
 *  Games launcher
 */

define(function(require, exports, module) {
    'use strict';

    var launcher = require('modules/launcher/launcher');
    const _ = require('underscore');
    var user = require('user');
    var core = require('core');
    var i18n = require('i18n');
    var device = require('util/device.util');
    var Base3rdPartyPlatform = require('modules/launcher/platforms/base.3rdParty.platform');
    var BaseModel = require('common/base.model');

    module.exports = _.extend(launcher, {

        _handleSuccessLogin: function(gameCode, mode, queryString, options) {
            if (device.isMobilePlatform) {
                return this.launchGame(gameCode, mode, queryString, options);
            }

            if (this._isLaunchInNewWindow(gameCode)) {
                var buttonTitle = i18n.t('playtech.mobile.system.button.realPlay');
                var popupContent = i18n.t('playtech.mobile.system.games.popup-blocker-with-confirm');

                window.Playtech.API.popup.showPopup({
                    content: popupContent,
                    buttons: [
                        {
                            text: buttonTitle,
                            onClick: () => this.launchGame(gameCode, mode, queryString, options)
                        }
                    ],
                    isModal: true,
                    layer: 'HIGH_PRIORITY',
                    closeAll: true,
                    onClose: function() {
                        core.trigger('page:refresh');
                    }
                });
            } else {
                this.launchGame(gameCode, mode, queryString, options);
            }
        },

        /**
         * Get url with params for game launch
         * @private
         * @param  {String} gameCode -- game code in gamesConfiguration
         * @param  {Number} mode     -- real or demo mode
         * @param  {String=} queryString -- additional URL params
         */
        _launch: function(gameCode, mode, queryString, options) {
            var game = this._getGame(gameCode);

            if (!game) {
                return;
            }

            user.set({
                launchedGame: {
                    queryString: queryString,
                    code: gameCode,
                    mode: mode,
                    options: options
                }
            });

            Base3rdPartyPlatform.setLauncher(this);
            Base3rdPartyPlatform.setAdditionalQueryString(queryString);
            Base3rdPartyPlatform.open(new BaseModel({ isInFavorites: false, ...game, idAttribute: 'gameCode' }), mode, options);

            if (options && options.isReactGame && options.onGameLaunched) {
                options.onGameLaunched();
            }
        },
    });
});
